var exports = {
  "X$": "viewportLayout__j4sZxm",
  "Y$": "sidebarFooter__WXXvtz",
  "$$": "pageContainer__iF8k1I",
  "fT": "homeContentPane__9p8WKh",
  "pX": "pageContent__vIgmJM",
  "Bw": "pageContainerWithTitle__1UyXBM",
  "me": "pageContentHome__EP7CKP",
  "ki": "pageDropTarget__-4mcvA",
  "zt": "pageDropOverlay__ZMGEAm",
  "n6": "pageIcon__hQi3GM",
  "xr": "homeContent__RFxQQ4",
  "sn": "aiDisclaimer__WaznEN",
  "Vr": "pageHeader__8hy7ko",
  "W": "pageTitle__UWg77w",
  "SM": "failedTaskBanners__W1ogMj",
  "ov": "taskChatHost__aKWnTd",
  "v2": "taskChatContent__1jaKF9",
};

module.exports = exports;
